import { getMaterials, initPackage } from 'material-loader'
import StaticLogger from '@sf-intl/reporter-sdk'

export const LoggerGetSingleMaterial = async() => {
  // 顺丰云生产环境-长链
  // const url = "https://freight.sf-express.com/material/packages/xvMebmq3CVnzfZFNeNJRmV/index.js";
  // 谷歌云生产环境-长链
  // const googleUrl = "https://storage.googleapis.com/sf-fe-artifact/prod/packages/xvMebmq3CVnzfZFNeNJRmV/index.js";
  // 短链
  const shortUrl = 'xvMebmq3CVnzfZFNeNJRmV'
  // 必须-初始化物料包信息
  initPackage(
    shortUrl,
    {},
    {
      env: 'sfOssProd',
      // 神策埋点配置
      sensor: {
        systemCode: 'IBU-ICAS-CORE-WEB', // 系统编码
      },
    }
  )
  // 加载物料包中的单个物料
  try {
    const res = await getMaterials('@sf-intl_reporter-sdk')
    console.log('%c Line:26 🥤 res', 'color:#fca650', res)
    if (res['@sf-intl_reporter-sdk'] && res['@sf-intl_reporter-sdk'].init) {
      return res['@sf-intl_reporter-sdk']
    }
    return StaticLogger
  } catch (error) {
    return StaticLogger
  }

  // 初始化埋点SDK-和之前的使用方式一样
}
